import React, { useMemo } from 'react';
import CarCard from './carCard';
import { NoDataFound } from '../elements/noDataFound';

export const LeasedCarList = ({
  carRef,
  selectedCar,
  carList,
  searchTerm,
  handleCardClick,
  isUsedInDocumentsSection = false,
}) => {
  const hasData = useMemo(() => {
    return searchTerm
      ? carList?.pages.some((page) => page.data && !!page.data.length)
      : true;
  }, [searchTerm, carList]);

  if (!hasData) {
    return (
      <li className="col-span-4 p-3 flex w-full items-center justify-center">
        <NoDataFound />
      </li>
    );
  }

  return (
    <>
      {carList?.pages.map((page) =>
        page.data?.map((item, index) => {
          const carData = {
            ...item,
            title: item.MakeName,
            subTitle: item?.ModelName,
            info: item.plateno,
          };
          if (page.data.length >= 3 && page.data.length - 3 === index) {
            return (
              <CarCard
                cardRef={carRef}
                carData={carData}
                selectedCar={selectedCar}
                handleCardClick={(e) => handleCardClick(item)}
                key={item.plateno}
                isUsedInDocumentsSection={isUsedInDocumentsSection}
              />
            );
          }

          return (
            <CarCard
              carData={carData}
              selectedCar={selectedCar}
              handleCardClick={(e) => handleCardClick(item)}
              key={item.plateno}
              isUsedInDocumentsSection={isUsedInDocumentsSection}
            />
          );
        })
      )}
    </>
  );
};

export default LeasedCarList;
